import React, { useState } from 'react'
import { Checkbox, Modal, Tooltip } from 'antd'
import { kasaRights } from '../../../components/_utils/appUtils'
import { createUnconditionalOfferLetterFxn } from '../actions/chooseStudent'
import { useDispatch } from 'react-redux'

const AcceptUnconditionalOfferLetter = (props) => {
  let { file, record, onRefresh } = props
  let user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
  let dispatch = useDispatch()
  let message = 'Once you accept the unconditional offer letter, the college will block your seat. You are required to apply for this student visa through UnizPortal. Failure to do so may result in the suspension of your account in the future.'
  const createUnconditionalOfferLetter = async () => {
    let obj = {
      studentId: record._id,
      applicationId: record.applications._id
    }
    let resp = await dispatch(createUnconditionalOfferLetterFxn(obj))
    if (resp && resp.success) {
      onRefresh()
    }
  }
  const confirmModal = (data) => {
    let confirmed = false

    const modal = Modal.confirm({
      width: '35%',
      title: (
        <div style={{ fontWeight: 'bold', fontSize: '18px', textDecoration: 'underline' }}>
          Accept Unconditional Offer Letter
        </div>
      ),
      content: (
        <div>
          <p>{message}</p>
          <Checkbox
            onChange={(e) => {
              confirmed = e.target.checked
              modal.update({
                okButtonProps: {
                  disabled: !confirmed
                }
              })
            }}
          >
            I hereby confirm my acceptance of the offer letter.
          </Checkbox>
        </div>
      ),
      okText: 'Accept',
      okButtonProps: {
        disabled: true
      },
      onOk() {
        if (confirmed) {
          createUnconditionalOfferLetter(data)
        }
      },
      onCancel() {
        // Optional: handle cancel
      },
      afterClose: () => {
        confirmed = false // Reset for next use
      }
    })
  }

  return (
    <div style={{ width: 140 }} className={'fcmtDiv'}>
      <div className={'d-flex flex-column align-items-center alignCenter'}>
        {file && file.path ? (
            <Tooltip title={'Download Offer Letter'}>
              <a download={file.fileName} href={file.path}>
                <img src={'../assets/icons/cloud-computing-download.png'} />
              </a>
            </Tooltip>
          ) :
          <div className={'alignCenter'}>
            <a className={'btn btn-default sm mt10 roundNew'}
               onClick={confirmModal}>Accept</a>
          </div>
        }
        {
          record && record.applications.combinedSeatNumber &&
          <span className='btn btn-default xs roundNew2 mt10 mr0'>
            Seat No - {record.applications.combinedSeatNumber}
          </span>
        }
      </div>


    </div>
  )
}
export default AcceptUnconditionalOfferLetter
